<section class="border-bottom">
  <div class="container p-0">
    <section>
      <div class="container">
        <div *ngIf="cart.length == 0">No items in cart</div>
        <div *ngFor="let item of cart; let i = index" class="pt-3">
          <div class="row m-0">
            <div class="col-md-12">
              <div class="h5">{{item.product.name}}</div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-md-4 col-sm-12 p-2">
              <div class="aspect-ratio-box-3-2"
                   [style.background-image]="!!item.product.media && item.product.media[0] && item.product.media[0].path ? safeStyle('url(' + item.product.media[0].path + ')') : ''"
                   [style.background-size]="'cover'"
                   [style.background-repeat]="'no-repeat'"
                   [style.background-position]="'center center'">
                <!--<img class="w-100" src="{{ BASE_MEDIA_URL }}{{!!item.product.path ? item.product.path : ''}}">-->
              </div>
            </div>
            <div class="col-md-8 col-sm-12 p-0 text-right">
              <!-- <div class="h5 mt-4">{{item.product.name}}</div> -->
              <!-- <div class="body mt-3">{{item.product.description}}</div> -->
              <div class="h4">
                ${{item.product.price.toFixed(2)}}
                <span *ngIf="!!item.upc">
                  ({{ (!!item.upc.attribute_set ? item.upc.attribute_set.attribute_value.value : item.upc.upc) }})
                </span></div>
              <div class="body-link primary1 mt-3" (click)="removeItem(item)">Remove Item</div>
              <div>
                <app-quantity-input [quantity]="item.quantity" (quantityChanged)="changeQuantity(item, $event)"></app-quantity-input>
              </div>
              <div class="ml-2 mt-2 mb-2 p-1 text-left extra cream-light-bg" *ngIf="!!item.extra && !!item.product.fields && item.product.fields.length > 0">
                <div class="row" *ngFor="let fieldData of sortFields(item.product.fields)">
                  <div class="col-4">{{ fieldData.name }}:</div>
                  <div class="col-8 text-wrap text-break">{{ item.extra[fieldData.name] }}</div>
                </div>
              </div>
            </div>
          </div>
          <hr *ngIf="i+1 < cart.length">
        </div>
      </div>
    </section>
  </div>
</section>

<section class="p-0 py-3 neutral9-bg">
  <div class="container">
    <!--<div class="row m-0">
      <div class="col-md-12 col-sm-12 p-0">
        <div class="h6"><u>Note: Due to COVID-19, all online orders will take 5-7 business days to be processed and ready to ship.  Thank you for your understanding.</u></div>
      </div>
    </div>-->
    <div class="row m-0 pt-3">
      <div class="col-md-9 col-sm-12 p-0">
        <div class="h6 neutral4">Subtotal</div>
        <div class="small mt-3">Shipping and taxes calculated at checkout.</div>
      </div>
      <div class="col-md-3 col-sm-12 p-0 text-right">
        <div class="h6 neutral3">Subtotal</div>
        <div class="h4 neutral3">${{ getSubTotal().toFixed(2) }}</div>
      </div>
    </div>

    <!-- SHIPPING RATE OPTIONS -->
    <div *ngIf="showComplete && !!shippingRates && showRate" class="row m-0 mt-5">
      <div class="col-12 p-0 body-copy">
        <div class="primary1-light pb-2 font-italic">Please select a shipping option</div>
        <ng-container *ngFor="let rate of shippingRates; let last = last">
          <div class="row">
            <!--<div class="col"><img [src]="rate.provider_image_75"> {{ rate.provider }}</div>-->
            <!--<div class="col">{{ rate.estimated_days }} days</div>-->
            <div class="col text-nowrap shipping-col">
              <input 
                type="radio" 
                name="shippingRate" 
                [checked]="selectedShippingRate === rate"
                (click)="setShippingRate(rate); showRate = false">
                            
              <!-- Render the name with line breaks / indentation -->
                <div class="shipping-name" [innerHTML]="rate.name"></div>
                <div [innerHTML]="rate.desc"></div>
            
            </div>
            
            <div class="col">${{ rate.amount }}</div>
          </div>

          <ng-container *ngIf="!last">
            <br><br>
          </ng-container>
          <!--<div class="row">-->
            <!--<div class="col-1">&nbsp;</div>-->
            <!--<div class="col-11">Estimated arrival: {{ rate.arrives_by }}</div>-->
          <!--</div>-->
        </ng-container>
      </div>
    </div>

    <!-- SHIPPING TOTALS -->
    <div *ngIf="showComplete && calculatingShipping" class="spinner-wrapper">
      <div class="clock-spinner">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div *ngIf="showComplete && (!!selectedShippingRate)" class="row m-0 mt-5">
      <div class="col-md-9 col-sm-12 p-0">
        <div class="h6 neutral4">Shipping</div>
        <div class="small mt-3" [innerHTML]="selectedShippingRate ? selectedShippingRate.name : 'Shipping cost for your address.'"></div>
      </div>
      <div class="col-md-3 col-sm-12 p-0 text-right">
        <div class="h6 neutral3">Shipping</div>
        <div class="h4 neutral3 mt-3"><a (click)="showRate=true" class="description !important cursor-pointer" style="padding-right: 4px;"><u>Edit</u></a>${{ selectedShippingRate.amount }}</div>
      </div>
    </div>

    <div *ngIf="showComplete && (!!salesTax)" class="row m-0 mt-5">
      <div class="col-md-9 col-sm-12 p-0">
        <div class="h6 neutral4">Sales Tax</div>
        <div class="small mt-3">{{ salesTaxMessage }}</div>
      </div>
      <div class="col-md-3 col-sm-12 p-0 text-right">
        <div class="h6 neutral3">Tax</div>
        <div class="h4 neutral3 mt-3">${{ salesTax }}</div>
      </div>
    </div>

    <div *ngIf="showComplete && (!!selectedShippingRate || noShippableItems)" class="row m-0 mt-5">
      <div class="col-md-9 col-sm-12 p-0">
        <div class="h6 neutral4">&nbsp;</div>
        <div class="small mt-3">&nbsp;</div>
      </div>
      <div class="col-md-3 col-sm-12 p-0 text-right">
        <div class="h6 neutral3">Total</div>
        <div class="h4 primary1">${{ getTotal().toFixed(2) }}</div>
      </div>
    </div>

    <div *ngIf="!!error" class="row m-0 mt-5">
      <div class="col-12 p-0 text-danger">
        <p>There was an error processing your purchase:</p>

        <p class="pl-2" [innerHTML]="error | html"></p>

        <p><a class="cursor-pointer" (click)="calculateAll()">Retry</a> <a class="cursor-pointer" style="margin-left: 20px;" (click)="showRate=true; error = null">Edit</a></p>
      </div>
    </div>

    <button 
      *ngIf="currentRoute === '/store/checkout'" 
      [disabled]="processingPayment || showRate || isEditingPayment || (selectedShippingRate == null || noShippableItems)" 
      class="btn btn-primary1 w-100 mt-5" 
      (click)="complete()">
      Complete Order
    </button>
  </div>
</section>
